import { actionCreatorFactory } from 'typescript-fsa';
const actionCreator = actionCreatorFactory('StoryPublish');

export interface PublishErrors {
  errors: string[];
  warnings: string[];
}

export const publishStoryLoad = actionCreator('STORY_PUBLISH_LOAD');
export const publishStory = actionCreator('STORY_PUBLISH');
export const publishErrors = actionCreator<PublishErrors>(
  'STORY_PUBLISH_ERRORS'
);

export const unpublishStory = actionCreator<{
  appConfigId: number;
  storyId: number;
}>('STORY_UNPUBLISH');



// WEBPACK FOOTER //
// ./src/store/StoryPublish/story-publish.actions.ts